/* PACKAGES */
import React from "react";
import { Link } from "react-router-dom";

/* ICONS */
import {
  IoCall,
  IoMail,
  IoLogoFacebook,
  IoLogoLinkedin,
  IoLogoInstagram,
} from "react-icons/io5";

/* NAVIGATION LINKS */
const navigationLinks = [
  {
    id: 1,
    route: "/",
    name: "Home",
  },
  {
    id: 2,
    route: "/about-us",
    name: "About Us",
  },
  {
    id: 3,
    route: "/pricing",
    name: "Pricing",
  },
  {
    id: 4,
    route: "/delete-account",
    name: "Delete Account",
  },
];

const Footer = () => {
  return (
    <footer className="bg-black">
      <div className="container">
        {/* NAVIGATION LINKS */}
        <div className="block xl:flex lg:flex items-center justify-between py-5">
          <Link to="/" className="block bg-white rounded-md p-2 w-fit">
            <img
              src={require("../assets/images/logo.png")}
              className="w-auto h-14 object-contain"
              alt="Alumni Connection Hub"
            />
          </Link>

          <div className="mt-5 xl:mt-0 lg:mt-0 flex items-center gap-8 gap-y-4 xl:gap-10 lg:gap-10 flex-wrap justify-start xl:justify-normal lg:justify-normal">
            {navigationLinks.map((data) => (
              <Link
                key={data.id}
                to={data.route}
                className="block text-white hover:text-logo text-opacity-80 font-normal text-base transition-all duration-300 ease-in-out"
              >
                {data.name}
              </Link>
            ))}
          </div>
        </div>

        {/* GET IN TOUCH */}
        <div className="py-8 border-t border-white border-opacity-40">
          <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 items-center">
            <div className="col-span-1">
              <h5 className="text-2xl font-roundo font-bold text-white">
                Get in touch with us
              </h5>
              <p className="text-sm font-normal text-white text-opacity-80">
                Connect with us to know about how our team can help you
              </p>
            </div>
            <div className="col-span-2 mt-5 xl:mt-0 lg:mt-0">
              <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-0 lg:gap-0 items-center">
                <div className="col-span-1">
                  <div className="flex items-center gap-5 group cursor-pointer">
                    <div className="w-12 h-12 bg-[#232327] rounded-full shrink-0 flex items-center justify-center">
                      <IoCall className="w-5 h-5 text-white group-hover:text-logo transition-all duration-300 ease-in-out" />
                    </div>
                    <div>
                      <h5 className="text-sm font-normal text-white text-opacity-80">
                        Give us a call
                      </h5>
                      <a
                        href="tel:+14244099020"
                        className="block text-lg font-semibold text-white group-hover:text-logo transition-all duration-300 ease-in-out"
                      >
                        +1 (424) 409-9020
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-span-1">
                  <div className="flex items-center gap-5 group cursor-pointer">
                    <div className="w-12 h-12 bg-[#232327] rounded-full shrink-0 flex items-center justify-center">
                      <IoMail className="w-5 h-5 text-white group-hover:text-logo transition-all duration-300 ease-in-out" />
                    </div>
                    <div>
                      <h5 className="text-sm font-normal text-white text-opacity-80">
                        Send us an email
                      </h5>
                      <a
                        href="mailto:vimal@roundtechsquare.com"
                        className="block text-lg font-semibold text-white group-hover:text-logo transition-all duration-300 ease-in-out"
                      >
                        vimal@roundtechsquare.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-span-1">
                  <div className="flex items-center justify-start xl:justify-end lg:justify-end gap-5">
                    <h5 className="text-sm font-normal text-white text-opacity-80">
                      Follow us on
                    </h5>
                    <div className="flex items-center gap-2">
                      <a
                        href="https://www.facebook.com/profile.php?id=61577160231570"
                        target="_blank"
                        rel="noreferrer"
                        className="w-10 h-10 bg-[#232327] rounded-full flex items-center justify-center text-white hover:text-logo transition-all duration-300 ease-in-out flex-shrink-0"
                      >
                        <IoLogoFacebook className="w-5 h-5" />
                      </a>
                      <a
                        href="https://www.instagram.com/alumniconnectionhub/"
                        target="_blank"
                        rel="noreferrer"
                        className="w-10 h-10 bg-[#232327] rounded-full flex items-center justify-center text-white hover:text-logo transition-all duration-300 ease-in-out flex-shrink-0"
                      >
                        <IoLogoInstagram className="w-5 h-5" />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/alumni-connection-hub/"
                        target="_blank"
                        rel="noreferrer"
                        className="w-10 h-10 bg-[#232327] rounded-full flex items-center justify-center text-white hover:text-logo transition-all duration-300 ease-in-out flex-shrink-0"
                      >
                        <IoLogoLinkedin className="w-5 h-5" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* COPYRIGHT FOOTER */}
        <div className="py-4 border-t border-white border-opacity-40">
          <div className="block xl:flex lg:flex items-center justify-center xl:justify-between lg:justify-between">
            <p className="text-sm font-normal text-white text-center xl:text-start lg:text-start">
              © Copyright 2025 Alumni Connection Hub. All Rights Reserved. A
              product by{" "}
              <a
                href="https://www.roundtechsquare.com"
                target="_blank"
                rel="noreferrer"
                className="text-[#06baef] font-medium"
              >
                RoundTechSquare
              </a>
            </p>

            {/* POLICIES */}
            <Link
              to="/privacy-policy"
              className="mt-3 xl:mt-0 lg:mt-0 block text-sm font-normal text-white text-center xl:text-start lg:text-start"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
